function init_parallax() {
    // 1
    $item = $('.vacature-direct-solliciteren__backdrop');

    if($item) {
        $item_img = $item.find('img');

        if($item_img) {
            new simpleParallax($item_img[0], {
                delay: .6,
                transition: 'cubic-bezier(0,0,0,1)'
            });
        }
    
    }

    // 2
    $item2 = $('.vacature-backdrop');

    if($item2) {
        $item2_img = $item2.find('img');

        if($item2_img) {
            new simpleParallax($item2_img[0], {
                delay: .6,
                transition: 'cubic-bezier(0,0,0,1)'
            });
        }
    
    }
}

$(document).ready(function() {
    init_parallax();
});